import { CreateSsoInput, UpdateSsoInput } from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const BASE_URL = import.meta.env.VITE_APP_BASE_URL;

export const getSsoConfig = async (customerId: string) => {
  try {
    const url = `${BASE_URL}/auth/sso/${customerId}`;
    const response = await axiosClient.get(url);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const createSsoConfig = async (data: CreateSsoInput) => {
  try {
    const url = `${BASE_URL}/auth/sso`;
    const response = await axiosClient.post(url, data);
    const resData = response?.data;
    // if (resData?.success && resData?.statusCode === 200) {
    if (resData?.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateSsoConfig = async (data: UpdateSsoInput) => {
  try {
    const url = `${BASE_URL}/auth/sso?ssoConnectorId=${data?.ssoConnectorId}`;
    const response = await axiosClient.patch(url, data);
    const resData = response?.data;
    // if (resData?.success && resData?.statusCode === 200) {
    if (resData?.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteSsoConfig = async (ssoConnectorId: string) => {
  try {
    const url = `${BASE_URL}/auth/sso?ssoConnectorId=${ssoConnectorId}`;
    const response = await axiosClient.delete(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
